"use client";
import {createContext, useContext, useState, ReactNode} from "react";

type Ctx = {
  /* desktop-left sidebar */
  open: boolean;
  toggle: () => void;
  close: () => void;

  /* mobile slide-in menu (right) */
  mobileOpen: boolean;
  toggleMobile: () => void;
  closeMobile: () => void;
};

const SidebarContext = createContext<Ctx | null>(null);

export function SidebarProvider({children}: {children: ReactNode}) {
  const [open, setOpen] = useState(true); // desktop sidebar
  const [mobileOpen, setMobileOpen] = useState(false); // mobile menu

  const toggle = () => setOpen((o) => !o);
  const close = () => setOpen(false);

  const toggleMobile = () => setMobileOpen((o) => !o);
  const closeMobile = () => setMobileOpen(false);

  return <SidebarContext.Provider value={{open, toggle, close, mobileOpen, toggleMobile, closeMobile}}>{children}</SidebarContext.Provider>;
}

export const useSidebar = () => {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error("useSidebar must be inside <SidebarProvider>");
  return ctx;
};
